let error_codes = {
  arr: [
    {
      id: "DATA_NOT_FOUND",
      code: 90001,
      description: "データが見つかりません"
    },
    {
      id: "DEVICE_ID_NOT_FOUND",
      code: 90002,
      description: "'端末番号'が見つかりません"
    },
    {
      id: "CONTROL_NUMBER_ALREADY_EXIST",
      code: 90003,
      description: "'管理番号'と'申請事項'はすでに存在しています！"
      // description: "'管理番号'はすでに存在しています！"
    },
    ,
    {
      id: "MYSQL_ERROR",
      code: 90004,
      description: "MySqlエラー"
    },
    {
      id: "DATA_DUPLICATED",
      code: 90005,
      description: "データの複製"
    },
    {
      id: "INVALID_DATA",
      code: 90006,
      description: "Invalid data"
    }
  ],
  getError: (code, def) => {
    var temp = {
      id: "UNDEFINED ERROR",
      code: code || "99999",
      description: def
    };
    error_codes.arr.forEach(d => {
      if (code == d.code) {
        temp = d;
      }
    });
    return temp;
  }
};

error_codes.arr.forEach(d => {
  // if(!RegExp("^[A-Z][A-Z0-9_]+$").test(d.id)){alert("Invalid error id " + d.id);};
  error_codes[d.id] = d.code;
});
module.exports = error_codes;



// WEBPACK FOOTER //
// ./src/rules/errors.js